module.exports = __webpack_public_path__ + "static/media/gw.df58afd4.svg";